export default __webpack_public_path__ + "static/media/100_19041.647a7ecc.jpg";